import _ from 'lodash';
import {
  WEIGHT_UNITS,
  GRAMS_IN_LBS,
  GRAMS_IN_OZ,
} from 'Pages/manageingredient/helpers/Constants';

export const formatValue = (value, ratio) => {
  if (isNaN(value) || !value) {
    return 'N/A';
  }
  return _.round(Number(value) * ratio, 3).toFixed(3);
};

export const getBaseWeightRatio = (baseWeight, baseWeightOGL) => {
  let ratio = 100 / baseWeight;
  switch (baseWeightOGL) {
    case WEIGHT_UNITS.OZ:
      ratio = 100 / (baseWeight * GRAMS_IN_OZ);
      break;
    case WEIGHT_UNITS.LB:
      ratio = 100 / (baseWeight * GRAMS_IN_LBS);
      break;
    default:
      break;
  }
  return ratio;
};



// WEBPACK FOOTER //
// ./src/common/Components/NutritionalFacts/helpers/nutritionalFacts.js